import "./History.scss";
import Lines from '../../components/Lines';
import Timeline from './Timeline/Timeline';

const History = () => {

    return (
        <>
            <section className="historyPageIntroSection">
                <header>
                    <h2 style={{ color: "#116C4A" }}>History of NICAS</h2>
                    <span className="lines-parent">
                        <Lines count={25} color="#116C4A" fontSize={2.3} spacing={0.1} thickness={700} />
                    </span>
                </header>

                <div className="bgImage">
                </div>

                <p>NICAS, started in 2001 by the Noorul Islam Educational Trust, is affiliated to Manonmaniam Sundaranar University. With a meagre strength of just 75 students, offering three courses namely Computer Science, Information Technology and Computer Applications, the College progressed leaps and bounds by adding new courses and infrastructural facilities. The college has an effective student strength of about 1500 and offers 14 U.G. courses and 5 P.G. courses. There are 80 members of the Teaching staff and 32 members of the Administrative staff. Among the Teaching staff, there are  65 Ph.D holders and the rest of them are NET/SLET qualified.</p>

                <p>The Institution's Innovation Council was established in the year 2020-2021. The college has completed 24 years of educational service.</p>
            </section>
            <Timeline />
        </>
    )
}

export default History
